import {useId} from 'react';

import {Field} from '../Field';
import {MultiSelect} from '../shadcn/multi-select';

import type {FieldProps} from '../Field';
import type {MultiSelectProps} from '../shadcn/multi-select';
import type {ReactNode} from 'react';

export interface FieldMultiSelectProps extends Omit<MultiSelectProps, 'id' | 'aria-invalid'> {
  // Field props
  label?: ReactNode;
  description?: ReactNode;
  error?: ReactNode;
  orientation?: FieldProps['orientation'];
  required?: boolean;
  // Escape hatch
  id?: string;
  triggerClassName?: string;
}

export function FieldMultiSelect({
  label,
  description,
  error,
  orientation,
  required,
  id,
  triggerClassName,
  badge,
  ...multiSelectProps
}: FieldMultiSelectProps) {
  const generatedId = useId();
  const resolvedId = id ?? generatedId;

  return (
    <Field
      label={label}
      description={description}
      error={error}
      htmlFor={resolvedId}
      orientation={orientation}
      required={required}
    >
      <MultiSelect
        id={resolvedId}
        aria-invalid={!!error || undefined}
        className={triggerClassName}
        badge={badge}
        {...multiSelectProps}
      />
    </Field>
  );
}
